import md5 from 'md5';

import { getVendor } from "config/vendors";
import { httpApiHost, oneWalletApiHost } from "config/hosts";
import { stringifyQuery } from "utils/query";

const version = '0.6';
const demoHallID = 7;

function xmlNodeValue(xmlDoc, name) {
    const elements = xmlDoc.getElementsByTagName(name);
    if (elements.length === 0 || elements[0].childNodes.length === 0) {
        return "";
    }
    if (name === "social") {
        const result = [];
        elements[0].childNodes.forEach(node => {
            if (node.nodeType === 1) {
                result.push({
                    type: node.nodeName,
                    url: node.textContent
                });
            }
        });

        return result;
    }
    return elements[0].childNodes[0].nodeValue;
}

export async function login(login, password, useHash) {

    const xml =
        `<request>
            <version>${version}</version>
            <user_id>${login}</user_id>
            <user_password>${password}</user_password>
            <use_hash>${useHash ? 1 : 0}</use_hash>
            <operation>check</operation>
            <host>${window.location.host}</host>
            <pathname>${window.location.pathname}</pathname>
            <show_packet>1</show_packet></request>`

    const payload = {
        reg_xml: btoa(xml),
        reg_sign: md5("hall_secret" + xml + "hall_secret")
    };

    const options = {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include',
        cache: 'no-store'
    };

    const response = await fetch(`${httpApiHost()}/remotecab_session`, options);
    const text = await response.text();
    const xmlText = '<?xml version="1.0"?>' + atob(text.replace(/\n/g, ''));
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml");

    const success = xmlNodeValue(xmlDoc, "status") === "success";
    if (!success) {
        throw new Error("HTTP API login failed");
    }

    let chatLinks = [];
    let promoenabled = "0";
    let promobalance = "0";
    try {
        chatLinks = xmlNodeValue(xmlDoc, "social") || [];
        promoenabled = xmlNodeValue(xmlDoc, "promoenabled") || "0";
        promobalance = xmlNodeValue(xmlDoc, "promobalance") || "0";
    } catch (e) { }

    let walletApiHost = "";
    try {
        walletApiHost = xmlNodeValue(xmlDoc, "walletapi") || "";
    } catch (e) { }

    return {
        uid: +xmlNodeValue(xmlDoc, "uid"),
        sid: +xmlNodeValue(xmlDoc, "sessionid"),
        key1: +xmlNodeValue(xmlDoc, "key1"),
        key2: +xmlNodeValue(xmlDoc, "key2"),
        hallId: +xmlNodeValue(xmlDoc, "hall_id"),
        remoteUrl: xmlNodeValue(xmlDoc, "remoteurl"),
        chatLinks: chatLinks,
        promoEnabled: parseInt(promoenabled, 10),
        promoBalance: parseInt(promobalance, 10),
        walletApiHost,
    }
}

export async function loginDemo() {

    const xml =
        `<request>
            <version>${version}</version>
            <operation>checkbysid</operation>
            <show_packet>1</show_packet>
            <pathname>${window.location.pathname}</pathname>
            <sessionid>777</sessionid>
            <key1>777</key1>
            <key2>777</key2>
        </request>`

    const payload = {
        reg_xml: btoa(xml),
        reg_sign: md5("hall_secret" + xml + "hall_secret")
    };

    const options = {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include',
        cache: 'no-store'
    };

    const response = await fetch(`${httpApiHost()}/remotecab_session`, options);
    const text = await response.text();
    const xmlText = '<?xml version="1.0"?>' + atob(text.replace(/\n/g, ''));
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml");

    const success = xmlNodeValue(xmlDoc, "status") === "success";
    if (!success) {
        throw new Error("login failed");
    }

    return {
        uid: +xmlNodeValue(xmlDoc, "uid"),
        sid: +xmlNodeValue(xmlDoc, "sessionid"),
        sidLo: 0x77777777,
        sidHi: 0x77777777,
        key1: 0x77777777,
        key2: 0x77777777,
        hallId: 7,
        useUUID: true,
        walletApiHost: ""
    }
}

export async function loginSid(sid, key1, key2) {

    const xml =
        `<request>
            <version>${version}</version>
            <sessionid>${sid}</sessionid>
            <key1>${key1}</key1>
            <key2>${key2}</key2>
            <operation>checkbysid</operation>
            <host>${window.location.host}</host>
            <pathname>${window.location.pathname}</pathname>
            <show_packet>1</show_packet></request>`

    const payload = {
        reg_xml: btoa(xml),
        reg_sign: md5("hall_secret" + xml + "hall_secret")
    };

    const options = {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include',
        cache: 'no-store'
    };

    const response = await fetch(`${httpApiHost()}/remotecab_session`, options);
    const text = await response.text();
    const xmlText = '<?xml version="1.0"?>' + atob(text.replace(/\n/g, ''));
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml");

    const success = xmlNodeValue(xmlDoc, "status") === "success";
    if (!success) {
        throw new Error("HTTP API login failed");
    }

    let chatLinks = [];
    let promoenabled = "0";
    let promobalance = "0";
    try {
        chatLinks = xmlNodeValue(xmlDoc, "social") || [];
        promoenabled = xmlNodeValue(xmlDoc, "promoenabled") || "0";
        promobalance = xmlNodeValue(xmlDoc, "promobalance") || "0";
    } catch (e) { }

    let walletApiHost = "";
    try {
        walletApiHost = xmlNodeValue(xmlDoc, "walletapi") || "";
    } catch (e) { }

    return {
        uid: +xmlNodeValue(xmlDoc, "uid"),
        sid: +xmlNodeValue(xmlDoc, "sessionid"),
        key1: +xmlNodeValue(xmlDoc, "key1"),
        key2: +xmlNodeValue(xmlDoc, "key2"),
        hallId: +xmlNodeValue(xmlDoc, "hall_id"),
        remoteUrl: xmlNodeValue(xmlDoc, "remoteurl"),
        chatLinks: chatLinks,
        promoEnabled: parseInt(promoenabled, 10),
        promoBalance: parseInt(promobalance, 10),
        walletApiHost,
    }
}

const isVendorProvided = (id) => {
    if (id >= 1024 && id <= 2599) {
        return true;
    }
    if (id >= 3500 && id <= 3700) {
        return true; // PG Soft
    }
    if (id >= 5300 && id <= 5448) {
        return true; // EGT Digital
    }
    if (id >= 5600 && id <= 5826) {
        return true; // Amatic
    }
    if (id >= 9000 && id <= 9107) {
        return true; // Playson
    }
    if (id >= 9300 && id <= 9500) {
        return true; // Habanero
    }

    return false;
}

export async function fetchGames(hallID) {
    const query = {
        type: window.STARGAME_DEBUG_ ? "all" : "html5",
        format: "json",
        nocache: 1
    };

    if (window.STARGAME_DEBUG_) {
        query.debug = 1;
    }

    if (hallID !== undefined && hallID !== null && hallID !== demoHallID && !window.STARGAME_DEBUG_) {
        query.hallid = hallID
    }

    const options = {
        method: 'GET',
        credentials: 'omit'
    };

    const response = await fetch(`${httpApiHost()}/remote_games_list?${stringifyQuery(query)}`, options);
    const text = await response.text();
    const families = JSON.parse(text).gamelist.map(elem => elem.family);

    const games = Object.keys(families).reduce((acc, curr) => {
        const games = families[curr].games.map(game => {
            const {
                buybonus,
                group,
                htmlposition,
                icon,
                id,
                jackpot,
                name,
                popularity,
                tournament,
                vendorflags,
            } = game;
            const family = families[curr].name;

            const vendorHot = (parseInt(vendorflags || 0) & (1 << 0)) > 0;
            const vendorNew = (parseInt(vendorflags || 0) & (1 << 1)) > 0;

            return {
                buybonus,
                category: group,
                family,
                icon,
                id,
                isVendorProvided: isVendorProvided(id),
                jackpot,
                name,
                popularity: popularity,
                position: htmlposition,
                tournament,
                vendor: getVendor(id, family),
                vendorFlags: vendorflags || 0,
                vendorHot,
                vendorNew,
            };
        });
        return acc.concat(games)
    }, []);
    return games;
}

export async function fetchLiveGamesNewLobby({ hallID, gameProvider }) {
    const options = {
        method: 'GET',
        credentials: 'omit'
    };

    const url = new URL(`${httpApiHost()}/remote_games_live`);
    if (hallID !== undefined) {
        url.searchParams.set('hallId', hallID);
    }
    if (gameProvider !== undefined) {
        url.searchParams.set('gameProvider', gameProvider);
    }
    url.searchParams.set('nocache', 1);

    const response = await fetch(url, options);
    const json = await response.json();
    return json;
}

export async function fetchGamesSettings(userID) {

    const query = {
        nocache: 1,
        uid: userID
    };

    const options = {
        method: 'GET',
        credentials: 'omit'
    };

    const response = await fetch(`${httpApiHost()}/remote_game_settings?${stringifyQuery(query)}`, options);
    const text = await response.text();
    return JSON.parse(text);
}

export async function fetchNewGames() {
    const query = {
        type: "html5",
        format: "json",
        nocache: 1
    };

    const options = {
        method: 'GET',
        credentials: 'omit'
    };

    const response = await fetch(`${httpApiHost()}/remote_games_list_new?${stringifyQuery(query)}`, options);
    const text = await response.text();
    return JSON.parse(text).gamelist.family.games;
}

export async function fetchTournamentDetails(tournamentId) {
    const url = new URL(`${httpApiHost()}/gettournaments`);
    url.search = new URLSearchParams({ tid: tournamentId }).toString() + "&details";
    const response = await fetch(url);
    return await response.json();
}

async function fetchJson(url, sessionProps, options) {
    const { sid, key1, key2, walletApiUsername } = sessionProps;
    url.searchParams.set('session', window.btoa(`${sid}.${key1}.${key2}.${window.btoa(walletApiUsername)}`));
    const response = await fetch(url, options);
    return response.json();
}

const v2GameIds = [6479, 4996, 4997, 4998, 4999, 4500, 4501, 4502];
const v2Providers = ['amatic', 'amaticdigital', 'playson', 'habanero', 'pg'];

export async function fetchVendorGameUrl({ queryKey }) {
    // eslint-disable-next-line no-unused-vars
    const [_, { gameProps, lang, sessionProps }] = queryKey;
    const { gameProvider, isLive, playMode, starTableId } = gameProps;

    if (gameProvider === 'egtdigital') {
        const { sid, key1, key2, walletApiUsername } = sessionProps;
        return Promise.resolve({
            link: `https://x7qz9jy.com/showgame?gameid=${starTableId}&sid=${sid}&key1=${key1}&key2=${key2}&username=${walletApiUsername}&uwidth=auto&uheight=auto&returnUrl=${window.location.href}`
        });
    }
    if (v2GameIds.includes(starTableId) || v2Providers.includes(gameProvider)) {
        const { sid, key1, key2, walletApiUsername } = sessionProps;
        const gameLang = lang || "";
        let link = `${process.env.REACT_APP_STARGAME_API_V2_URL}/public/player/openGame?gameid=${starTableId}&sid=${sid}&key1=${key1}&key2=${key2}&username=${walletApiUsername}&lang=${gameLang}&returnUrl=${window.location.href}`;
        if (window.location.hostname.includes("debug")) {
            link += '&staging';
        }
        return Promise.resolve({ link: link });
    }

    const isEmbedded = !window.location.hostname.includes("apiserver.solutions");
    const unlockKey = new URL(window.location.href).searchParams.get("unlock");

    const options = {
        method: 'GET',
        credentials: 'omit',
        ...isEmbedded ? ({
            headers: {
                ...(isLive && { 'X-Star-Games': '/games' }),
                ...(unlockKey !== '' && { 'X-Unlock-Key': unlockKey })
            }
        }) : ({
            headers: {
                ...(isLive && { 'X-Star-Games': '/public/tote' }),
                ...(unlockKey !== '' && { 'X-Unlock-Key': unlockKey })
            }
        }),
    };

    const url = new URL(`${oneWalletApiHost(sessionProps)}/public/launch`);
    url.searchParams.set('starTableId', starTableId);
    url.searchParams.set('playMode', playMode || 'real');

    return fetchJson(url, sessionProps, options);
}

export async function vendorGameLogout(session, gameProvider) {
    const { sid, key1, key2, walletApiUsername } = session;
    const url = new URL(`${oneWalletApiHost(session)}/public/logout`);
    url.searchParams.set('gameProvider', gameProvider);
    url.searchParams.set('session', window.btoa(`${sid}.${key1}.${key2}.${window.btoa(walletApiUsername)}`));
    return navigator.sendBeacon(url);
}